export default __webpack_public_path__ + "static/media/interior.da008d0f.svg";